import { css } from 'styled-components';
const BREAKPOINTS = {
    mobile: 768,
    tablet: 1200,
    desktop: 1201,
};
export const media = {
    mobile: (styles) => css `
    @media screen and (max-width: ${BREAKPOINTS.mobile}px) {
      ${styles}
    }
  `,
    tablet: (styles) => css `
    @media screen and (max-width: ${BREAKPOINTS.tablet}px) {
      ${styles}
    }
  `,
    desktop: (styles) => css `
    @media screen and (min-width: ${BREAKPOINTS.desktop}px) {
      ${styles}
    }
  `,
};
//# sourceMappingURL=breakpoints.js.map